import { lazy } from 'react'

import { MotorTradeBuyLinks } from '@/enums/motorTradeBuySteps'
import {
  MotorTradeRTL,
  MotorTradeS2,
  MotorTradeS2RTL,
} from '@/enums/motorTradeTestSteps'

export const MotorTradeBuyRouter = () => {
  const usedRouter = window.location?.href.includes(
    'motortrade-roadrisks-s2-rtl'
  )
    ? MotorTradeS2RTL
    : window.location?.href.includes('motortrade-roadrisks-rtl')
      ? MotorTradeRTL
      : window.location?.href.includes('motortrade-roadrisks-s2')
        ? MotorTradeS2
        : MotorTradeBuyLinks

  return {
    step1: {
      element: lazy(() => import('@/steps/MotorTrade/Step1')),
      href: usedRouter.Step1,
    },
    step2: {
      element: lazy(() => import('@/steps/MotorTrade/Step2')),
      href: usedRouter.Step2,
    },
    step3: {
      element: lazy(() => import('@/steps/MotorTrade/Step3')),
      href: usedRouter.Step3,
    },
    step4: {
      element: lazy(() => import('@/steps/MotorTrade/Step4')),
      href: usedRouter.Step4,
    },
    step5: {
      element: lazy(() => import('@/steps/MotorTrade/Step5')),
      href: usedRouter.Step5,
    },
    step6: {
      element: lazy(() => import('@/steps/MotorTrade/Step6')),
      href: usedRouter.Step6,
    },
    step7: {
      element: lazy(() => import('@/steps/MotorTrade/Step7')),
      href: usedRouter.Step7,
    },
    step8: {
      element: lazy(() => import('@/steps/MotorTrade/Step8')),
      href: usedRouter.Step8,
    },
    step9: {
      element: lazy(() => import('@/steps/MotorTrade/Step9')),
      href: usedRouter.Step9,
    },
    step10: {
      element: lazy(() => import('@/steps/MotorTrade/Step10')),
      href: usedRouter.Step10,
    },
    step11: {
      element: lazy(() => import('@/steps/MotorTrade/Step11')),
      href: usedRouter.Step11,
    },
    step12: {
      element: lazy(() => import('@/steps/MotorTrade/Step12')),
      href: usedRouter.Step12,
    },
    step13: {
      element: lazy(() => import('@/steps/MotorTrade/Step13')),
      href: usedRouter.Step13,
    },
    step14: {
      element: lazy(() => import('@/steps/MotorTrade/StepSummary')),
      href: usedRouter.Step14,
    },
  }
}
